import { ActivitySpinnerSize, ActivitySpinnerWidget } from '@tableau/widgets';
import * as React from 'react';

import { CommonStyles } from '../../commonInfra/styles/CommonStyles';
import { sanitize } from '../../commonInfra/utils/Sanitize';
import { HiddenUserStyles } from '../../spacesPlatform/components/spaceComponents/SpacesStyles';

import { setupUIBindingForReactFunctionalComponent } from '../common/UIBindingForReact';
import { ContentDefinitions } from '../models/ContentDefinitions';
import { ContentSuggestionViewModel } from '../viewModels/ContentSuggestionViewModel';
import { EmptyStateContentSuggestionViewModel } from '../viewModels/EmptyStateContentSuggestionViewModel';
import { activeSectionItem, alignCenter, contentSuggestionSectionItem, contentSuggestionSectionItemContent, contentSuggestionSectionItemIcon, section, sectionItem, sectionItemAutoFitContent, sectionItemFixedContent, sectionItemHorizontalLayout, useColorForHighlight } from './OmniboxV2Styles';

export const ContentSuggestionTestId = 'ContentSuggestion';

export function ContentSuggestion(props: { viewModel: ContentSuggestionViewModel }): JSX.Element {
    const viewModel = props.viewModel;
    setupUIBindingForReactFunctionalComponent(viewModel);

    return renderContentSuggestionItems(viewModel);
}

export function renderContentSuggestionItems(viewModel: ContentSuggestionViewModel | EmptyStateContentSuggestionViewModel): JSX.Element {
    return (!viewModel.contentSuggestionItems || viewModel.contentSuggestionItems.length > 0) ? <div data-tb-test-id={ContentSuggestionTestId} className={[section, 'tb-quicklinks-section-divider', (viewModel.omniboxViewModel.shouldUseColorHighlight() ? useColorForHighlight : null)].join(' ')}>
        {
            viewModel.contentSuggestionItems ? viewModel.contentSuggestionItems.map((item, index) => {
                const contentDefinition = ContentDefinitions[item.contentType];

                return <a id={item.getIdentifier()} key={index} href={item.url} role='option' aria-selected={item === viewModel.currentKeyboardNavigableItem}
                    onClick={(event) => { event.preventDefault(); event.stopPropagation(); viewModel.onItemClicked(item, index); }}
                    className={[sectionItem, sectionItemHorizontalLayout, contentSuggestionSectionItem, (item === viewModel.currentKeyboardNavigableItem ? activeSectionItem : '')].join(' ')}>
                    <div className={[sectionItemFixedContent, contentSuggestionSectionItemIcon].join(' ')}>
                        <img src={item.icon} alt='' />
                    </div>
                    <div className={[sectionItemAutoFitContent, contentSuggestionSectionItemContent].join(' ')}>
                        <div className={sectionItemHorizontalLayout}>
                            <div className={sectionItemAutoFitContent} style={CommonStyles.Layout.TextEllipsis} dangerouslySetInnerHTML={{
                                __html:
                                    sanitize(item.titleHtml)
                            }}>
                            </div>
                            <div className={sectionItemFixedContent}>
                                {item.supportingData}
                            </div>
                        </div>
                        <div className='extra-icons'>
                            {
                                item.extraIcons?.map(extraIcon =>
                                    <>
                                        <span><img src={extraIcon} alt='' style={{ transform: 'translate(0, 2px)' }} /></span>
                                        <span>&nbsp;&bull;&nbsp;</span>
                                    </>)
                            }
                            <span>{contentDefinition.getName()}</span>
                            {item.ownerHtml ? <span>&nbsp;&bull;&nbsp;</span> : null}
                            <span className={item.hiddenOwner ? HiddenUserStyles.HiddenUserClassName : ''} dangerouslySetInnerHTML={{
                                __html:
                                    sanitize(item.ownerHtml)
                            }}></span>
                        </div>
                    </div>
                </a>;
            })
                : <div className={alignCenter} style={{ height: '134px' }}>
                    <ActivitySpinnerWidget
                        spinnerSize={ActivitySpinnerSize.Small}
                        testId={'omnibox-pending'}
                    />
                </div>
        }
    </div>
        : null;
}